export const statusColors = {
  pendente: { bg: '#fff3e0', color: '#e65100', label: 'Pendente' },
  enviado: { bg: '#e3f2fd', color: '#1565c0', label: 'Enviada' },
  autorizado: { bg: '#e8f5e9', color: '#2e7d32', label: 'Autorizada' },
  realizado: { bg: '#e3f2fd', color: '#0d47a1', label: 'Realizada' },
  negado: { bg: '#ffebee', color: '#c62828', label: 'Negada' },
  erro: { bg: '#fce4ec', color: '#c62828', label: 'Erro' },
  cancelado: { bg: '#f5f5f5', color: '#757575', label: 'Cancelada' },
  nao_enviado: { bg: '#f5f5f5', color: '#999', label: 'Nao Enviada' },
  aceito: { bg: '#e8f5e9', color: '#2e7d32', label: 'Aceito' },
  rejeitado: { bg: '#ffebee', color: '#c62828', label: 'Rejeitado' },
  parcial: { bg: '#fff8e1', color: '#f57f17', label: 'Parcial' },
};

// Mapeamento statusSolicitacao TISS (XSD dm_statusSolicitacao)
export const STATUS_SOLICITACAO_MAP = {
  '1': { label: 'Autorizado', color: '#2e7d32' },
  '2': { label: 'Negado', color: '#c62828' },
  '3': { label: 'Autorizado Parcial', color: '#e65100' },
  '4': { label: 'Cancelado pelo Prestador', color: '#757575' },
  '5': { label: 'Cancelado pela Operadora', color: '#c62828' },
};

export const opLabels = {
  teste_conexao: 'Teste de Conexao',
  elegibilidade: 'Elegibilidade',
  solicitacao_procedimento: 'Solicitacao de Guia',
  worker_envio_guia: 'Envio Automatico',
  reenvio_guia: 'Reenvio de Guia',
  status_guia: 'Status da Guia',
  cancelamento_guia: 'Cancelamento de Guia',
  envio_lote: 'Envio de Lote',
  reenvio_lote: 'Reenvio de Lote',
  status_lote: 'Status do Lote',
};

export const LOCAL_MAP = { '01': 'Matriz', '02': 'Itapecerica', '04': 'Pedra do Indaia', 'CA': 'Camacho' };

export const localLabel = (l) => LOCAL_MAP[(l || '').trim()] || l;

export const GUIA_STATUS_LIST = [
  { id: 'a_enviar', label: 'A Enviar', statusFilter: null },
  { id: 'enviado', label: 'Enviadas', statusFilter: 'enviado' },
  { id: 'autorizado', label: 'Autorizadas', statusFilter: 'autorizado' },
  { id: 'realizado', label: 'Realizadas', statusFilter: 'realizado' },
  { id: 'negado', label: 'Negadas', statusFilter: 'negado' },
  { id: 'erro', label: 'Erros', statusFilter: 'erro' },
  { id: 'todas', label: 'Todas', statusFilter: '' },
];

export const LOTE_STATUS_LIST = [
  { id: 'pendente', label: 'Pendentes', statusFilter: 'pendente' },
  { id: 'enviado', label: 'Enviados', statusFilter: 'enviado' },
  { id: 'aceito', label: 'Aceitos', statusFilter: 'aceito' },
  { id: 'rejeitado', label: 'Rejeitados', statusFilter: 'rejeitado' },
  { id: 'erro', label: 'Erros', statusFilter: 'erro' },
  { id: 'todos', label: 'Todos', statusFilter: '' },
];
